import {
  ACTIVATE_USER,
  ACTIVATE_USER_ERROR,
  ACTIVATE_USER_START,
  ADD_USER,
  ADD_USER_ERROR,
  ADD_USER_PROTENANT,
  ADD_USER_PROTENANT_ERROR,
  ADD_USER_PROTENANT_START,
  ADD_USER_START,
  CLEAR_ERROR_USER,
  CLEAR_USER_LIST,
  DEACTIVATE_USER,
  DEACTIVATE_USER_ERROR,
  DEACTIVATE_USER_START,
  DELETE_USER,
  DELETE_USER_ERROR,
  DELETE_USER_START,
  GET_USER,
  GET_USER_ALLOWED_ACTIONS_LIST,
  GET_USER_ALLOWED_ACTIONS_LIST_ERROR,
  GET_USER_ERROR,
  GET_USER_LIST,
  GET_USER_LIST_BY_KJS_MUNICIPALITY,
  GET_USER_LIST_BY_KJS_MUNICIPALITY_ERROR,
  GET_USER_LIST_BY_KJS_MUNICIPALITY_START,
  GET_USER_LIST_ERROR,
  GET_USER_LIST_FILTER,
  GET_USER_LIST_FILTER_ERROR,
  GET_USER_LIST_FILTER_START,
  GET_USER_LIST_PAGEABLE,
  GET_USER_LIST_START,
  GET_USER_START,
  UPDATE_USER,
  UPDATE_USER_ERROR,
  UPDATE_USER_START,
} from './types';
import {
  filterPageablePath,
  userActivatePath,
  userAddPath,
  userDeactivatePath,
  userDeletePath,
  userFindAllAllowedActionsPath,
  userFindAllPageablePath,
  userFindAllPath,
  userFindByIdPath,
  userProtenatAddPath,
  userUpdatePath,
  usersByKJSMunicipalityPath,
} from '../constants/apiEndpoints';
import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';

import apiService from '../utils/apiService';
import { createNotification } from '../utils';

const clearUserList = () => {
  return {
    type: CLEAR_USER_LIST,
  };
};

const clearError = () => {
  return {
    type: CLEAR_ERROR_USER,
  };
};

const addUserStart = () => {
  return {
    type: ADD_USER_START,
  };
};
const addUserSuccessfully = (data) => {
  return {
    type: ADD_USER,
    payload: data,
  };
};
const addUserUnsuccessfully = (err) => {
  return {
    type: ADD_USER_ERROR,
    payload: err,
  };
};

const updateUserStart = () => {
  return {
    type: UPDATE_USER_START,
  };
};
const updateUserSuccessfully = (data) => {
  return {
    type: UPDATE_USER,
    payload: data,
  };
};
const updateUserUnsuccessfully = (err) => {
  return {
    type: UPDATE_USER_ERROR,
    payload: err,
  };
};

const getUserStart = () => {
  return {
    type: GET_USER_START,
  };
};
const getUserSuccessfully = (data) => {
  return {
    type: GET_USER,
    payload: data,
  };
};
const getUserUnsuccessfully = (err) => {
  return {
    type: GET_USER_ERROR,
    payload: err,
  };
};

const getUserListStart = () => {
  return {
    type: GET_USER_LIST_START,
  };
};
const getUserListSuccessfully = (data) => {
  return {
    type: GET_USER_LIST,
    payload: data,
  };
};

const getUserPageableListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_USER_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};

const getUserListUnsuccessfully = (err) => {
  return {
    type: GET_USER_LIST_ERROR,
    payload: err,
  };
};

const deleteUserStart = () => {
  return {
    type: DELETE_USER_START,
  };
};
const deleteUserSuccessfully = (id) => {
  return {
    type: DELETE_USER,
    payload: id,
  };
};
const deleteUserUnsuccessfully = (err) => {
  return {
    type: DELETE_USER_ERROR,
    payload: err,
  };
};

const deactivateUserStart = () => {
  return {
    type: DEACTIVATE_USER_START,
  };
};
const deactivateUserSuccessfully = (data) => {
  return {
    type: DEACTIVATE_USER,
    payload: data,
  };
};
const deactivateUserUnsuccessfully = (err) => {
  return {
    type: DEACTIVATE_USER_ERROR,
    payload: err,
  };
};

const activateUserStart = () => {
  return {
    type: ACTIVATE_USER_START,
  };
};
const activateUserSuccessfully = (data) => {
  return {
    type: ACTIVATE_USER,
    payload: data,
  };
};
const activateUserUnsuccessfully = (err) => {
  return {
    type: ACTIVATE_USER_ERROR,
    payload: err,
  };
};

const getUserAllowedActionsSuccessfully = (data) => {
  return {
    type: GET_USER_ALLOWED_ACTIONS_LIST,
    payload: data,
  };
};

const getUserAllowedActionsUnsuccessfully = (err) => {
  return {
    type: GET_USER_ALLOWED_ACTIONS_LIST_ERROR,
    payload: err,
  };
};

export const deleteErrorUser = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

const addUserProtenantStart = () => {
  return {
    type: ADD_USER_PROTENANT_START,
  };
};
const addUserProtenantSuccessfully = (data) => {
  return {
    type: ADD_USER_PROTENANT,
    payload: data,
  };
};

const addUserProtenantUnsuccessfully = (err) => {
  return {
    type: ADD_USER_PROTENANT_ERROR,
    payload: err,
  };
};

const getUserListByKJSMunicipalityStart = () => {
  return {
    type: GET_USER_LIST_BY_KJS_MUNICIPALITY_START,
  };
};
const getUserListByKJSMunicipalitySuccessfully = (data) => {
  return {
    type: GET_USER_LIST_BY_KJS_MUNICIPALITY,
    payload: data,
  };
};

const getUserListByKJSMunicipalityUnsuccessfully = (err) => {
  return {
    type: GET_USER_LIST_BY_KJS_MUNICIPALITY_ERROR,
  };
};
const getUserFilterListStart = () => {
  return {
    type: GET_USER_LIST_FILTER_START,
  };
};
const getUserFilterListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_USER_LIST_FILTER,
    payload: [data, pageNumber, totalElements],
  };
};
const getUserFilterListUnsuccessfully = (err) => {
  return {
    type: GET_USER_LIST_FILTER_ERROR,
    payload: err,
  };
};

export const createUser = (user, callback, messages) => {
  return (dispatch) => {
    dispatch(addUserStart());
    return apiService
      .post(userAddPath(), user)
      .then((response) => {
        dispatch(addUserSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          messages.userTitle,
          messages.creationSuccessMessage
        );
      })
      .catch((err) => {
        dispatch(addUserUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messages.errorTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const updateUser = (user, callback, messages) => {
  return (dispatch) => {
    dispatch(updateUserStart());
    return apiService
      .post(userUpdatePath(), user)
      .then((response) => {
        dispatch(updateUserSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          messages.userTitle,
          messages.updateSuccessMessage
        );
      })
      .catch((err) => {
        dispatch(updateUserUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messages?.errorTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const findUserById = (id) => {
  return (dispatch) => {
    dispatch(getUserStart());
    return apiService
      .get(userFindByIdPath(id))
      .then((response) => {
        dispatch(getUserSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllUsers = () => {
  return (dispatch) => {
    dispatch(getUserListStart());
    return apiService
      .get(userFindAllPath())
      .then((response) => {
        dispatch(getUserListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllUsersPageble = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getUserListStart());
    return apiService
      .get(userFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getUserPageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getUserUnsuccessfully(err?.response?.data));
      });
  };
};

export const deleteUser = (id) => {
  return (dispatch) => {
    dispatch(deleteUserStart());
    return apiService
      .patch(userDeletePath(id))
      .then(() => {
        dispatch(deleteUserSuccessfully(id));
      })
      .catch((err) => {
        dispatch(deleteUserUnsuccessfully(err?.response?.data));
      });
  };
};

export const deactivateUser = (id) => {
  return (dispatch) => {
    dispatch(deactivateUserStart());
    return apiService
      .patch(userDeactivatePath(id))
      .then((response) => {
        dispatch(deactivateUserSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(deactivateUserUnsuccessfully(err?.response?.data));
      });
  };
};

export const activateUser = (id) => {
  return (dispatch) => {
    dispatch(activateUserStart());
    return apiService
      .patch(userActivatePath(id))
      .then((response) => {
        dispatch(activateUserSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(activateUserUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllUserAllowedActions = (id, controllerReference) => {
  return (dispatch) => {
    return apiService
      .get(userFindAllAllowedActionsPath(id, controllerReference))
      .then((response) => {
        dispatch(getUserAllowedActionsSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserAllowedActionsUnsuccessfully(err?.response?.data));
      });
  };
};

export const createUserProtenant = (user, callback, messages) => {
  return (dispatch) => {
    dispatch(addUserProtenantStart());
    return apiService
      .post(userProtenatAddPath(), user)
      .then((response) => {
        dispatch(addUserProtenantSuccessfully(response.data));
        dispatch(createUser(user, callback, messages));
      })
      .catch((err) => {
        let message = '';
        const res = JSON.parse(err.response.data.message);
        if (res?.response?.code === 2001) {
          message = messages.invalidUmcnError;
          dispatch(
            addUserProtenantUnsuccessfully(err?.response?.data?.response)
          );
          createNotification(
            notificationTypeError,
            messages.errorTitle,
            message
          );
        } else if (
          res?.response?.code === 1001 ||
          res?.response?.code === 1111 ||
          res?.response?.code === 1110
        ) {
          dispatch(createUser(user, callback, messages));
        }
      });
  };
};

export const findAllUsersByKJSMunicipality = (kjsMunicipalityId) => {
  return (dispatch) => {
    dispatch(getUserListByKJSMunicipalityStart());
    return apiService
      .get(usersByKJSMunicipalityPath(kjsMunicipalityId))
      .then((response) => {
        dispatch(getUserListByKJSMunicipalitySuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getUserListByKJSMunicipalityUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const removeUserList = () => {
  return (dispatch) => {
    dispatch(clearUserList());
  };
};
export const findAllUserFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getUserFilterListStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getUserFilterListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(getUserFilterListUnsuccessfully(err?.response?.data));
      });
  };
};
